import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=a752656a&scoped=true&lang=pug&"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordModal.vue?vue&type=style&index=0&id=a752656a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a752656a",
  null
  
)

component.options.__file = "ChangePasswordModal.vue"
export default component.exports